<!--
	TEMPLATE
-->
<template>
	<div>
		<transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">
		<div class="list mdc-card">
			<a :href="'/properties/' + property.propertyId" class="mdc-card__media mdc-card__media-item--3x" @click.prevent="$router.push('/properties/' + property.propertyId)" v-bind:style="{backgroundImage: 'url(\''+ s3url(property.mainImage, 'medium') +'\')'}">
				<div class="overlay">
					<h1 class="mdc-card__title mdc-card__title--large list__title">{{ propertyStatus }}<!--<br>{{ property.serviceTypeId === 1 ? 'Sales' : 'Lettings' }}--></h1>
				</div>
			</a>
			<section class="mdc-card__actions">
				<div class="list__content">
					<div class="list__info">
						<a :href="'/properties/' + property.propertyId" class="list__name" @click.prevent="$router.push('/properties/' + property.propertyId)">{{ propertyAddress(property) }}</a>
						<br>
						<span class="">{{ price }}</span><span class="list__details-beds">&nbsp;&nbsp;{{ bedsAndType }}</span>
					</div>
				</div>
				<!--a href="#" class="list__more-btn" :class="{'list__more-btn--translate': showMore}" @click.prevent="toggleMore"><i class="ico-arrow"></i></a-->
			</section>

			<transition >
				<div v-show="showMore" class="list__actions mdc-card__horizontal-block" :class="{'list__actions--translate': showMore}">

					<!-- action btns -->

					<div class="event-box__btn-wrapper mdc-layout-grid">
					  <div class="mdc-layout-grid__inner">
					    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet">
							 <button class="mdc-button mdc-button--raised" @click="$router.push('/properties/edit/' + property.propertyId)">Edit</button>
						 </div>
					    <!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet">
							 <button class="mdc-button mdc-button--raised">Send email matches</button>
						 </div>
					    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet">
							 <button class="mdc-button mdc-button--raised">Send SMS matches</button> -->
						 <!-- </div> -->
						 <!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet">
							 <button class="mdc-button mdc-button--raised" @click.prevent="deleteProperty(property.id, index)">Delete Property</button>
						 </div> -->
						 <!--div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet" v-if="property.rmUrl != '' && property.rmUrl != null">
	 						<a :href="property.rmUrl" target="_blank" class="mdc-button mdc-button--raised">Rightmove link</a>
	 					</div>
	 					<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet" v-if="property.zooplaUrl != '' && property.zooplaUrl != null">
	 						<a :href="property.zooplaUrl" target="_blank" class="mdc-button mdc-button--raised">Zoopla link</a>
	 					</div-->
					  </div>
					</div>
				</div>
			</transition>
		</div>
		</transition>
	</div>
</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';

export default {
	props: {
		value: Array,
		property: [Object, Array],
		arrayIndex: Number
	},
	data: function() {
		return {
			show: true,
			showMore: false,
			showSection: true,
		}
	},
	mixins: [utils],
	computed: {
		propertyStatus: function() {
      if (!this.property.serviceType || !this.property.status || !this.$store.state.propertyLists.propertyStatus[this.property.serviceType] || !this.$store.state.propertyLists.propertyStatus[this.property.serviceType][this.property.status]) {
        return '';
      }
			return this.$store.state.propertyLists.propertyStatus[this.property.serviceType][this.property.status];
		},
		price: function() {
			const formatedPrice = this.formatCurrency(this.property.price);
			if (this.property.serviceType == 'lettings') {
				return formatedPrice + ' ' + (this.property.rentFrequency ? this.property.rentFrequency : 'pcm');
			} else {
				return formatedPrice;
			}
		},
		bedsAndType: function() {
			var summary = ''
		  if(this.property.bedrooms == 0) {
			  summary += 'Studio';
		  } else {
				summary += ' ' + this.property.bedrooms + ' bedroom';
			}
			if (this.property.bedrooms !== 0) {
				summary += ' ' + this.propertyTypeName(this.property.type).toLowerCase();
			}
		  return summary;
	  }
	},
	methods: {
		toggleMore: function() {
			this.showSection = !this.showSection;
			this.showMore = !this.showMore;
		},
		deleteProperty: function(id, arrayIndex) {
    		if(confirm('Are you sure you want to delete this property?')) {
				/*
	    			this.$http.delete(config.services.deleteProperty + '/' + id).then(function(response) {
						if (arrayIndex === undefined) {
							this.show = false;
						} else {
							this.$emit('remove', arrayIndex)
							this.showMore = false
						}
		    	    }, function(response) {
		    	    	console.log('error:');
		    	    	console.log(response);
		        	});
					*/
    		}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/PropertyBox.vue